import { shouldUseEntraId } from "../config/authConfig";
import EntraIdLogin from "../components/EntraIdLogin";
import EmailLogin from "../components/EmailLogin";

/**
 * Conditional Login Component
 * - Production: Uses Entra ID (Microsoft Azure AD) with role-based access
 * - Development: Uses email/OTP authentication
 */
export default function Login() {
  const useEntraId = shouldUseEntraId();

  return useEntraId ? <EntraIdLogin /> : <EmailLogin />;
}
